import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { instructorMenuItems } from '../../Data/Navigation/InstructorMenuData'
import { useLayout } from '../../Hooks/useLayout'

const InstructorHorizontalMenu = ({ isCompact }) => {
	const [isOpen, setIsOpen] = useState(false)
	const menuRef = useRef(null)
	const location = useLocation()
	const layout = useLayout()

	const isActive = (path) => {
		return location.pathname.startsWith(`${process.env.PUBLIC_URL}${path}`)
	}

	const toggleMenu = () => setIsOpen(!isOpen)

	// Close menu when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setIsOpen(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [])

	// Close menu on route change
	useEffect(() => {
		setIsOpen(false)
	}, [location])

	return (
		<div className={`instructor-horizontal-menu ${isCompact ? 'compact-rows' : ''}`} ref={menuRef}>
			{/* Mobile Toggle Button */}
			<button className="mobile-menu-toggle d-lg-none" onClick={toggleMenu} aria-label="Toggle navigation">
				<i className={`fa ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
			</button>

			<nav className={`horizontal-nav ${isOpen ? 'is-open' : ''}`}>
				<ul className="nav-list">
					{instructorMenuItems.map((item, index) => (
						<li key={index} className="nav-item">
							<Link
								to={`${process.env.PUBLIC_URL}${item.path}/${layout}`}
								className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
								onClick={() => setIsOpen(false)}
							>
								<span className="nav-text">{item.title}</span>
							</Link>
						</li>
					))}
				</ul>
			</nav>
		</div>
	)
}

export default InstructorHorizontalMenu
